module.exports = __webpack_public_path__ + "img/farzana-christopher-92.96903fc0.jpg";